import {css} from 'aphrodite';
import React from 'react';

import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import runModal from 'ui-library/runModal';

import AutomationFileConfigFileFormatInput from '../AutomationFileConfigFileFormatInput';
import {
  AutomationInputFileConfigEditorProps,
  automationFileConfigStyles,
  SectionNumber,
} from '../AutomationFileConfigUtils';
import {
  labAutomationFileDelimiterOptions,
  labAutomationFileExtensionOptions,
} from '../RunSchemaSpecConstants';
import {InputFileNamePart, InputFileNamePartType} from './AutomationInputFileConfigConstants';
import InputFileNameTemplate from './InputFileNameTemplate';
import SetInputFileNameTemplateModal from './SetInputFileNameTemplateModal';

const defaultNameTemplateParts: Array<InputFileNamePart> = [
  {type: InputFileNamePartType.RUN_SCHEMA_NAME},
  {type: InputFileNamePartType.TEXT, text: '_'},
  {type: InputFileNamePartType.RUN_ID},
  {type: InputFileNamePartType.TEXT, text: '_'},
  {type: InputFileNamePartType.CREATED_AT_DATE},
  {type: InputFileNamePartType.TEXT, text: 'T'},
  {type: InputFileNamePartType.CREATED_AT_TIME},
];

export default function AutomationInputFileConfigEditorFormatSection(
  props: AutomationInputFileConfigEditorProps
): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection)}>
      <SectionNumber sectionNumber={5} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure file format</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        Choose the format that works best with your lab equipment.
      </div>
      <div className={css(automationFileConfigStyles.formatSectionContents)}>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label="File name" labelStyle={LabelStyle.LABEL} />
          <br />
          <InputFileNameTemplate
            nameTemplateParts={props.inputFileConfig.nameTemplateParts ?? defaultNameTemplateParts}
            schemaFields={props.baseSchema.allFields}
          />
          <Button
            icon="edit"
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={() => {
              runModal(SetInputFileNameTemplateModal, {
                runSchema: props.baseSchema,
                forOutputFileConfig: false,
                automationFileConfig: props.inputFileConfig,
                initialNameTemplateParts: props.inputFileConfig.nameTemplateParts ?? defaultNameTemplateParts,
                onRequestSubmit: (nameTemplateParts) => {
                  props.onUpdateConfig({
                    ...props.inputFileConfig,
                    nameTemplateParts,
                  });
                },
              });
            }}
          />
        </div>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label="File extension" labelStyle={LabelStyle.LABEL} />
          <br />
          <AutomationFileConfigFileFormatInput
            label="File extension"
            options={labAutomationFileExtensionOptions}
            value={props.inputFileConfig.fileExtension}
            onSelect={(value: string) => {
              props.onUpdateConfig({
                ...props.inputFileConfig,
                fileExtension: value,
              });
            }}
          />
        </div>
        <div className={css(automationFileConfigStyles.formatSectionItem)}>
          <FieldLabel label="Delimiter" labelStyle={LabelStyle.LABEL} />
          <br />
          <AutomationFileConfigFileFormatInput
            label="Delimiter"
            options={labAutomationFileDelimiterOptions}
            value={props.inputFileConfig.delimiter}
            onSelect={(value: string) => {
              props.onUpdateConfig({
                ...props.inputFileConfig,
                delimiter: value,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}
